import React from 'react';
import { gql, useQuery } from '@apollo/client';
import SellerHeatMapLaunchpad from '../components/Succession/SellerHeatMapLaunchpad';

const GET_SELLER_HEATMAP = gql`
  query GetSellerHeatmap {
    sumByProvinceOptimized
  }
`;

const SellerHeatMapLaunchpadContainer = ({ heatmapEnabled }) => {
  if (!heatmapEnabled) return null;

  return <SellerHeatMapLaunchpadInner />;
};

// Inner component so the hook only runs when heatmap is enabled
const SellerHeatMapLaunchpadInner = () => {
  const { data, loading, error } = useQuery(GET_SELLER_HEATMAP, {
    fetchPolicy: 'cache-first',
  });

  const provinceData = loading || error ? {} : (data?.sumByProvinceOptimized || {});

  return (
    <SellerHeatMapLaunchpad
      data={provinceData}
      loading={loading}
      error={error}
    />
  );
};

export default SellerHeatMapLaunchpadContainer;
